import { css } from '@emotion/css';

export const setBackground = (background: string) => css`
  background: ${background};
`;
